//src/admin/pages/AdminCreateBXGYDiscount.js
import React, { useState, useContext, useEffect, useMemo } from "react";
import { useRef } from "react";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import AdminSidebar from "../AdminSidebar";
import AdminHeader from "../AdminHeader";
import { AdminLanguageContext } from "../context/AdminLanguageContext";
import { FaBox, FaCalendarAlt, FaClock, FaSearch } from "react-icons/fa";
import { FiChevronRight, FiAlertCircle } from "react-icons/fi";
import {
  getAdminProducts,
  getAdminCategories,
  createAdminDiscount,
} from "../../services/adminProducts.api";
import { removeProductsFromSale } from "../../services/adminProducts.api";
import { getAdminCustomers } from "../../services/adminCustomers.api";
import { updateAdminDiscount } from "../../services/adminDiscounts.api";
import { getAdminDiscountById } from "../../services/adminDiscounts.api";

function AdminCreateBXGYDiscount() {
  const navigate = useNavigate();
const { id } = useParams();
const initialRef = useRef(null);

const isEdit = !!id;

  const customerPickerRef = useRef(null);
  const { lang } = useContext(AdminLanguageContext);
  const [isOpen, setIsOpen] = useState(false);

  // ================= STATE =================
  const [discountType, setDiscountType] = useState("percentage");
  const [discountValue, setDiscountValue] = useState("");

  const [saving, setSaving] = useState(false);

  const [appliesToType, setAppliesToType] = useState("products");

  // BUY
const [selectedBuyProduct, setSelectedBuyProduct] = useState(null);
  const [selectedBuyCategories, setSelectedBuyCategories] = useState([]);

// GET
const [selectedGetProduct, setSelectedGetProduct] = useState(null);
const [selectedGetCategories, setSelectedGetCategories] = useState([]);

const [selectionTarget, setSelectionTarget] = useState("buy"); 
// "buy" | "get"

  const [products, setProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const [selectionModalOpen, setSelectionModalOpen] = useState(false);

  const [isActive, setIsActive] = useState(1); // 1 = active, 0 = inactive

  // ================= CUSTOMERS =================
const [customers, setCustomers] = useState([]);
const [customerSearch, setCustomerSearch] = useState("");

const [selectedCustomers, setSelectedCustomers] = useState([]);

const [eligibility, setEligibility] = useState("all"); // "all" | "specific"

const [customerPickerOpen, setCustomerPickerOpen] = useState(false);

  const [isDirty, setIsDirty] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const [showLeaveConfirm, setShowLeaveConfirm] = useState(false);
  const [pendingNavigation, setPendingNavigation] = useState(null);

  const [minRequirement, setMinRequirement] = useState("none");
  const [minAmount, setMinAmount] = useState("");
  const [minQty, setMinQty] = useState("");

  const [productSearch, setProductSearch] = useState("");

  const [usageLimitType, setUsageLimitType] = useState("none");
  const [usageLimit, setUsageLimit] = useState("");

  const [buyQty, setBuyQty] = useState("");
  const [getQty, setGetQty] = useState("");
  const [getDiscountType, setGetDiscountType] = useState("free"); 
  // "free" | "percentage"

  const [getDiscountValue, setGetDiscountValue] = useState("");

  const [productCategoryFilter, setProductCategoryFilter] = useState("");

  const [confirmRemoveSaleOpen, setConfirmRemoveSaleOpen] = useState(false);
  const [removeSaleProduct, setRemoveSaleProduct] = useState(null);

  const [startDate, setStartDate] = useState("");
  const [startTime, setStartTime] = useState("");
  const [hasEnd, setHasEnd] = useState(false);
  const [endDate, setEndDate] = useState("");
  const [endTime, setEndTime] = useState("");

  const [loadingDiscount, setLoadingDiscount] = useState(isEdit);

  const [categorySearch, setCategorySearch] = useState("");

  // DATE MODAL
  const [dateModalOpen, setDateModalOpen] = useState(false);
  const [dateTarget, setDateTarget] = useState(null); // "start" | "end"

  const [buyAppliesTo, setBuyAppliesTo] = useState("products");
  const [getAppliesTo, setGetAppliesTo] = useState("products");

  // TIME MODAL
  const [timeModalOpen, setTimeModalOpen] = useState(false);
  const [timeTarget, setTimeTarget] = useState(null); // "start" | "end"

  // calendar temp
  const [rangeStart, setRangeStart] = useState(null);
  const [rangeEnd, setRangeEnd] = useState(null);

  const [tempTime, setTempTime] = useState({
  hour: 12,
  minute: "00",
  period: "AM",
});

  // ================= UI =================
const card = "bg-white border border-[#e1e3e5] rounded-[18px] shadow-sm p-4 space-y-4";

  const subtitle = "text-[13px] text-[#6d7175]";

  const input =
  "w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none bg-white text-[#202223] focus:border-[#008060] focus:ring-1 focus:ring-[#008060] transition";

const select =
  "appearance-none w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm outline-none bg-white text-[#202223] focus:border-[#008060] transition";

const smallInput =
  "h-[36px] rounded-[10px] border border-[#c9cccf] px-3 text-sm outline-none bg-white text-[#202223] focus:border-[#008060]";

  const formatDisplayDate = (date) => {
  if (!date) return new Date().toLocaleDateString();
  return new Date(date).toLocaleDateString();
};

const formatDisplayTime = (time) => {
  if (!time) {
    return new Date().toLocaleTimeString([], {
      hour: "numeric",
      minute: "2-digit",
    });
  }

  const [h, m] = time.split(":");
  const date = new Date();
  date.setHours(h, m);

  return date.toLocaleTimeString([], {
    hour: "numeric",
    minute: "2-digit",
  });
};

const filteredProducts = useMemo(() => {
  const q = productSearch.trim().toLowerCase();

  return products.filter((p) => {
    const id = (p.public_id || "").toLowerCase();
    const nameEn = (p.name_en || "").toLowerCase();
    const nameAr = (p.name_ar || "").toLowerCase();

    const matchesSearch =
      !q ||
      id.includes(q) ||
      nameEn.includes(q) ||
      nameAr.includes(q);

    const matchesCategory =
  !productCategoryFilter ||
  p.categories?.includes(
    categories.find(c => String(c.id) === String(productCategoryFilter))?.slug
  );
    return matchesSearch && matchesCategory;
  });
}, [products, productSearch, productCategoryFilter]);

const filteredCategories = useMemo(() => {
  const q = categorySearch.trim().toLowerCase();

  if (!q) return categories;

  return categories.filter((c) => {
    const nameEn = (c.name_en || "").toLowerCase();
    const nameAr = (c.name_ar || "").toLowerCase();

    return nameEn.includes(q) || nameAr.includes(q);
  });
}, [categories, categorySearch]);

const CalendarRangePicker = ({ rangeStart, rangeEnd, setRangeStart, setRangeEnd }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const startOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth(), 1);
  const endOfMonth = new Date(currentMonth.getFullYear(), currentMonth.getMonth() + 1, 0);

  const startDay = startOfMonth.getDay();

  const days = [];

  for (let i = 0; i < startDay; i++) days.push(null);

  for (let d = 1; d <= endOfMonth.getDate(); d++) {
    days.push(new Date(currentMonth.getFullYear(), currentMonth.getMonth(), d));
  }

  const isSameDay = (a, b) =>
    a && b &&
    a.getFullYear() === b.getFullYear() &&
    a.getMonth() === b.getMonth() &&
    a.getDate() === b.getDate();

  const handleClick = (day) => {
    setRangeStart(day);
    setRangeEnd(day);
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-3 px-2">
        <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() - 1)))}>‹</button>

        <div className="font-semibold text-sm">
          {currentMonth.toLocaleString(lang === "AR" ? "ar" : "en", {
            month: "long",
            year: "numeric",
          })}
        </div>

        <button onClick={() => setCurrentMonth(new Date(currentMonth.setMonth(currentMonth.getMonth() + 1)))}>›</button>
      </div>

      <div className="grid grid-cols-7 gap-1">
        {days.map((day, i) => {
          if (!day) return <div key={i} />;

          const selected = isSameDay(day, rangeStart);

          return (
            <button
              key={i}
              onClick={() => handleClick(day)}
              className={`h-8 rounded-md text-sm ${
                selected ? "bg-black text-white" : "hover:bg-gray-200"
              }`}
            >
              {day.getDate()}
            </button>
          );
        })}
      </div>
    </div>
  );
};

const TimePicker = ({ tempTime, setTempTime }) => {
  const hours = Array.from({ length: 12 }, (_, i) => i + 1);
  const minutes = ["00", "15", "30", "45"];
  const periods = ["AM", "PM"];

  return (
    <div className="flex gap-3">

      {/* HOURS */}
      <div className="flex-1">
        <div className="text-xs text-gray-500 mb-2">Hour</div>
        <div className="grid grid-cols-3 gap-2">
          {hours.map(h => (
            <button
              key={h}
              onClick={() => setTempTime(prev => ({ ...prev, hour: h }))}
              className={`
                h-9 rounded-lg text-sm
                ${tempTime.hour === h ? "bg-black text-white" : "hover:bg-gray-200"}
              `}
            >
              {h}
            </button>
          ))}
        </div>
      </div>

      {/* MINUTES */}
      <div className="flex-1">
        <div className="text-xs text-gray-500 mb-2">Min</div>
        <div className="flex flex-col gap-2">
          {minutes.map(m => (
            <button
              key={m}
              onClick={() => setTempTime(prev => ({ ...prev, minute: m }))}
              className={`
                h-9 rounded-lg text-sm
                ${tempTime.minute === m ? "bg-black text-white" : "hover:bg-gray-200"}
              `}
            >
              {m}
            </button>
          ))}
        </div>
      </div>

      {/* AM / PM */}
      <div className="flex flex-col gap-2">
        <div className="text-xs text-gray-500 mb-2"></div>
        {periods.map(p => (
          <button
            key={p}
            onClick={() => setTempTime(prev => ({ ...prev, period: p }))}
            className={`
              h-9 px-3 rounded-lg text-sm
              ${tempTime.period === p ? "bg-black text-white" : "hover:bg-gray-200"}
            `}
          >
            {p}
          </button>
        ))}
      </div>

    </div>
  );
};

const filteredCustomers = useMemo(() => {
  const q = customerSearch.trim().toLowerCase();

  if (!q) return customers.slice(0, 8);

  return customers.filter((c) =>
    (c.name || "").toLowerCase().includes(q) ||
    (c.email || "").toLowerCase().includes(q) ||
    (c.phone || "").toLowerCase().includes(q)
  );
}, [customers, customerSearch]);

const buildSummary = () => {
  if (!buyQty || !getQty) {
    return lang === "AR"
      ? "ابدأ في إعداد العرض..."
      : "Start configuring your offer...";
  }

  const getText =
    getDiscountType === "free"
      ? (lang === "AR"
          ? `${getQty} مجانًا`
          : `${getQty} free`)
      : (lang === "AR"
          ? `${getQty} بخصم ${getDiscountValue}%`
          : `${getQty} with ${getDiscountValue}% off`);

  return lang === "AR"
    ? `اشترِ ${buyQty} واحصل على ${getText}.`
    : `Buy ${buyQty} items and get ${getText}.`;
};

const isSaveDisabled =
  saving ||
  !buyQty ||
  !getQty ||
  (getDiscountType === "percentage" && !getDiscountValue);

const handleSave = async () => {
  if (isSaveDisabled) return;

  try {
    setSaving(true);

const buildDateTime = (date, time) => {
  if (!date) return null;
  return time ? `${date} ${time}:00` : `${date} 00:00:00`;
};

const payload = {
  type: "bxgy",

  buyQty: Number(buyQty),
  getQty: Number(getQty),

  getDiscountType,
  getDiscountValue: Number(getDiscountValue || 0),

  selectedBuyProducts: selectedBuyProduct ? [selectedBuyProduct] : [],
  selectedGetProducts: selectedGetProduct ? [selectedGetProduct] : [],

  is_active: isActive,

  // ✅ ADD THESE
  start_at: buildDateTime(startDate, startTime),
  end_at: hasEnd ? buildDateTime(endDate, endTime) : null,
};

if (isEdit) {
  await updateAdminDiscount(id, payload);
} else {
  await createAdminDiscount(payload);
}

    setIsDirty(false);
    setShowConfirm(false);
    navigate("/admin/discounts");
  } catch (err) {
    console.error("Failed to create discount:", err);
    alert(
      lang === "AR"
        ? "فشل إنشاء الخصم"
        : "Failed to create discount"
    );
  } finally {
    setSaving(false);
  }
};

const handleNavigate = (path) => {
  if (!isDirty) {
    navigate(path);
  } else {
    setPendingNavigation(() => () => navigate(path));
    setShowLeaveConfirm(true);
  }
};

useEffect(() => {
  getAdminCustomers().then(setCustomers).catch(() => {});
}, []);

useEffect(() => {
  if (!isEdit) return;

  const loadDiscount = async () => {
    try {
      setLoadingDiscount(true);

      const d = await getAdminDiscountById(id);

      if (!d) {
        console.error("Discount not found");
        navigate("/admin/discounts");
        return;
      }

      setIsActive(d.is_active ?? 1);
      setDiscountType(d.discount_type || "percentage");
      setDiscountValue(String(d.discount_value || ""));
      setAppliesToType(d.applies_to || "products");

      setBuyQty(d.buy_qty != null ? String(d.buy_qty) : "");
      setGetQty(d.get_qty != null ? String(d.get_qty) : "");
      setGetDiscountType(d.get_discount_type || "free");
      setGetDiscountValue(
        d.get_discount_value != null ? String(d.get_discount_value) : ""
      );

      setMinRequirement(d.min_requirement || "none");
      setMinAmount(d.min_amount != null ? String(d.min_amount) : "");
      setMinQty(d.min_qty != null ? String(d.min_qty) : "");

      if (d.once_per_customer) {
        setUsageLimitType("once");
        setUsageLimit("");
      } else if (d.usage_limit) {
        setUsageLimitType("limit");
        setUsageLimit(String(d.usage_limit));
      } else {
        setUsageLimitType("none");
        setUsageLimit("");
      }

      if (d.start_at) {
  const dt = new Date(d.start_at);

  const date = dt.toISOString().slice(0, 10); // YYYY-MM-DD
  const time = dt.toTimeString().slice(0, 5); // HH:MM

  setStartDate(date);
  setStartTime(time);
} else {
  setStartDate("");
  setStartTime("");
}

      if (d.end_at) {
  const dt = new Date(d.end_at);

  const date = dt.toISOString().slice(0, 10);
  const time = dt.toTimeString().slice(0, 5);

  setHasEnd(true);
  setEndDate(date);
  setEndTime(time);
} else {
  setHasEnd(false);
  setEndDate("");
  setEndTime("");
}

setSelectedBuyProduct(
  d.buyProducts?.[0]
    ? {
        id: d.buyProducts[0].id,
        name: lang === "AR"
          ? (d.buyProducts[0].name_ar || d.buyProducts[0].name_en)
          : (d.buyProducts[0].name_en || d.buyProducts[0].name_ar),
      }
    : null
);

setSelectedGetProduct(
  d.getProducts?.[0]
    ? {
        id: d.getProducts[0].id,
        name: lang === "AR"
          ? (d.getProducts[0].name_ar || d.getProducts[0].name_en)
          : (d.getProducts[0].name_en || d.getProducts[0].name_ar),
      }
    : null
);

// ✅ ADD THIS HERE
initialRef.current = {
  buyQty: String(d.buy_qty || ""),
  getQty: String(d.get_qty || ""),
  getDiscountType: d.get_discount_type || "free",
  getDiscountValue: String(d.get_discount_value || ""),
  selectedBuyProductId: d.buyProducts?.[0]?.id || null,
  selectedGetProductId: d.getProducts?.[0]?.id || null,
  isActive: d.is_active ?? 1,
  startDate: d.start_at ? new Date(d.start_at).toISOString().slice(0, 10) : "",
  startTime: d.start_at ? new Date(d.start_at).toTimeString().slice(0, 5) : "",
  endDate: d.end_at ? new Date(d.end_at).toISOString().slice(0, 10) : "",
  endTime: d.end_at ? new Date(d.end_at).toTimeString().slice(0, 5) : "",
  hasEnd: !!d.end_at,
};

// ✅ KEEP THIS
setIsDirty(false);
    } catch (err) {
      console.error("Failed to load discount:", err);
    } finally {
      setLoadingDiscount(false);
    }
  };

  loadDiscount();
}, [id, isEdit, lang, navigate]);

useEffect(() => {
  function handleClickOutside(e) {
    if (
      customerPickerRef.current &&
      !customerPickerRef.current.contains(e.target)
    ) {
      setCustomerPickerOpen(false);
    }
  }

  if (customerPickerOpen) {
    document.addEventListener("mousedown", handleClickOutside);
  }

  return () => {
    document.removeEventListener("mousedown", handleClickOutside);
  };
}, [customerPickerOpen]);


useEffect(() => {
  getAdminProducts().then(setProducts).catch(() => {});
  getAdminCategories().then(setCategories).catch(() => {});

  // ✅ INIT FOR CREATE MODE
  if (!isEdit && !initialRef.current) {
    initialRef.current = {
      buyQty: "",
      getQty: "",
      getDiscountType: "free",
      getDiscountValue: "",
      selectedBuyProductId: null,
      selectedGetProductId: null,
      isActive: 1,
      startDate: "",
      startTime: "",
      endDate: "",
      endTime: "",
      hasEnd: false,
    };
  }
}, [isEdit]);

useEffect(() => {
  if (!initialRef.current) return;

  const current = {
    buyQty,
    getQty,
    getDiscountType,
    getDiscountValue,
    selectedBuyProductId: selectedBuyProduct?.id || null,
    selectedGetProductId: selectedGetProduct?.id || null,
    isActive,
    startDate,
    startTime,
    endDate,
    endTime,
    hasEnd,
  };

  const initial = initialRef.current;

  const isChanged = Object.keys(initial).some(
    key => String(initial[key]) !== String(current[key])
  );

  setIsDirty(isChanged);
}, [
  buyQty,
  getQty,
  getDiscountType,
  getDiscountValue,
  selectedBuyProduct,
  selectedGetProduct,
  isActive,
  startDate,
  startTime,
  endDate,
  endTime,
  hasEnd,
]);

if (loadingDiscount) {
  return (
    <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "AR" ? "lg:mr-26" : "lg:ml-64"}`}>
        <AdminHeader setIsOpen={setIsOpen} />

        <main className="px-3 py-4 sm:p-6">
          <div className="max-w-[1040px] mx-auto">
            <div className="bg-white border border-[#e1e3e5] rounded-[18px] shadow-sm p-8 text-sm text-[#6d7175]">
              {lang === "AR" ? "جارٍ تحميل بيانات الخصم..." : "Loading discount data..."}
            </div>
          </div>
        </main>
      </div>
    </div>
  );
}

  return (
    <div className={`flex bg-[#f1f1f1] min-h-screen ${isOpen ? "overflow-hidden" : ""}`}>
      <AdminSidebar isOpen={isOpen} setIsOpen={setIsOpen} />

      <div className={`flex-1 ${lang === "AR" ? "lg:mr-26" : "lg:ml-64"}`}>
        <AdminHeader
          setIsOpen={setIsOpen}
          customCenter={
            <div
              className={`
                hidden sm:block
                w-full
                sm:max-w-[500px]
                max-w-full
                transition-all duration-300
                ${isDirty ? "opacity-100 translate-y-0" : "opacity-0 -translate-y-2 pointer-events-none"}
              `}
            >
              <div className="bg-[#2c2c2c] border border-[#3a3a3a] rounded-md px-3 py-2 sm:py-[4px] space-y-2 sm:space-y-0 sm:flex sm:items-center sm:justify-between">

                {/* LEFT */}
                <div className="flex items-center gap-2 text-[13px] text-gray-200 justify-between sm:justify-start">
                  <FiAlertCircle className="text-white text-[16px]" />
                  <span>
                    {isEdit
          ? (lang === "AR" ? "تعديلات غير محفوظة" : "Unsaved changes")
          : (lang === "AR" ? "خصم غير محفوظ" : "Unsaved discount")}
                  </span>
                </div>

                {/* RIGHT */}
                <div className="flex gap-2 sm:gap-1.5 w-full sm:w-auto">

                  {/* DISCARD */}
                  <button
                    type="button"
                    onClick={() => handleNavigate("/admin/discounts")}
                    className="
                      px-2 py-[2px]
                      text-[12px]
                      rounded-md
                      border border-[#3a3a3a]
                      bg-[#1f1f1f]
                      hover:bg-[#363636]
                      text-gray-200
                      transition
                    "
                  >
                    {lang === "AR" ? "إلغاء" : "Discard"}
                  </button>

                  {/* SAVE */}
                  <button
                      type="button"
                      onClick={() => setShowConfirm(true)}
                      disabled={isSaveDisabled}
                      className={`
                        px-2 py-[2px]
                        text-[12px]
                        rounded-md
                        font-medium
                        transition
                        ${
                          isSaveDisabled
                            ? "bg-gray-400 text-gray-200 cursor-not-allowed"
                            : "bg-white text-black hover:bg-gray-200"
                        }
                      `}
                    >
                      {saving ? (lang === "AR" ? "جارٍ الحفظ..." : "Saving...") : (lang === "AR" ? "حفظ" : "Save")}
                    </button>

                </div>
              </div>
            </div>
          }
        />

        <main className="px-3 xl:p-3 sm:p-5">
         <div className="max-w-[1040px] mx-auto">

          {/* HEADER (same as product page) */}
          <div className="flex items-center gap-2 mb-5">
  <button
    onClick={() => handleNavigate("/admin/discounts")}
    className="w-8 h-8 flex items-center justify-center rounded-md hover:bg-gray-200"
  >
    <img
  src="/icons/discountNotSelected.png"
  alt="discount"
  className="w-[18px] h-[18px] object-contain"
/>
  </button>

            <FiChevronRight />

            <span className="font-semibold text-[#202223]">
              {isEdit
                ? (lang === "AR" ? "تعديل خصم" : "Edit Discount")
                : (lang === "AR" ? "إنشاء خصم" : "Create Discount")}
            </span>
          </div>

<div className="sm:hidden mb-4 flex gap-2">
  <button
    type="button"
    onClick={() => handleNavigate("/admin/discounts")}
    className="flex-1 h-[42px] rounded-[12px] border border-[#c9cccf] bg-white text-[#202223] font-medium"
  >
    {lang === "AR" ? "إلغاء" : "Discard"}
  </button>

  <button
    type="button"
    onClick={() => setShowConfirm(true)}
    disabled={isSaveDisabled}
    className={`flex-1 h-[42px] rounded-[12px] font-medium transition ${
      isSaveDisabled
        ? "bg-gray-300 text-gray-500 cursor-not-allowed"
        : "bg-[#202223] text-white hover:bg-black"
    }`}
  >
    {saving ? (lang === "AR" ? "جارٍ الحفظ..." : "Saving...") : (lang === "AR" ? "حفظ" : "Save")}
  </button>
</div>

          {/* GRID */}
          <div className="grid grid-cols-1 xl:grid-cols-[minmax(0,1fr)_340px] gap-3">

            {/* ================= LEFT ================= */}
            <div className="space-y-3">

              {/* SECTION 1 */}
              <div className={card}>
  <h3 className="text-[15px] font-semibold text-[#202223]">
    {lang === "AR" ? "اشترِ X واحصل على Y" : "Buy X get Y"}
  </h3>

  <p className={subtitle}>
    {lang === "AR"
      ? "حدد الكمية المطلوبة والكمية المجانية أو المخفضة"
      : "Define how many items customer buys and what they get"}
  </p>

  <div className="grid grid-cols-2 gap-3">

    {/* BUY */}
    <div>
      <label className="text-xs text-[#6d7175] block mb-1">
        {lang === "AR" ? "الكمية المطلوبة (X)" : "Customer buys (X)"}
      </label>
      <input
        type="number"
        value={buyQty}
        onChange={(e) => setBuyQty(e.target.value)}
        className={input}
        placeholder="2"
      />
    </div>

    {/* GET */}
    <div>
      <label className="text-xs text-[#6d7175] block mb-1">
        {lang === "AR" ? "يحصل على (Y)" : "Customer gets (Y)"}
      </label>
      <input
        type="number"
        value={getQty}
        onChange={(e) => setGetQty(e.target.value)}
        className={input}
        placeholder="1"
      />
    </div>

  </div>

  {/* DISCOUNT TYPE */}
  <div className="mt-3">
    <label className="text-xs text-[#6d7175] block mb-1">
      {lang === "AR" ? "نوع الخصم" : "Discount on Y"}
    </label>

    <select
      value={getDiscountType}
      onChange={(e) => setGetDiscountType(e.target.value)}
      className={select}
    >
      <option value="free">
        {lang === "AR" ? "مجاني" : "Free"}
      </option>

      <option value="percentage">
        {lang === "AR" ? "نسبة مئوية" : "Percentage"}
      </option>
    </select>
  </div>

  {/* VALUE IF % */}
  {getDiscountType === "percentage" && (
    <div className="mt-3">
      <label className="text-xs text-[#6d7175] block mb-1">
        {lang === "AR" ? "قيمة الخصم %" : "Discount value %"}
      </label>

      <input
        type="number"
        value={getDiscountValue}
        onChange={(e) => setGetDiscountValue(e.target.value)}
        className={input}
        placeholder="50"
      />
    </div>
  )}
</div>

              {/* SECTION 2 */}
              <div className={card}>
  <h3 className="text-[15px] font-semibold">
    {lang === "AR" ? "العميل يشتري من" : "Customer buys from"}
  </h3>


  <div className="flex gap-2">
    <input
      value={productSearch}
      onFocus={() => {
        setSelectionTarget("buy");
        setProductSearch("");
setProductCategoryFilter("");
setSelectionModalOpen(true);
      }}
      className={input}
      placeholder={lang === "AR" ? "ابحث..." : "Search..."}
    />

    <button
      onClick={() => {
        setSelectionTarget("buy");
        setProductSearch("");
setProductCategoryFilter("");
setSelectionModalOpen(true);
      }}
      className="
    w-[110px] h-[42px]
    rounded-[12px]
    border border-[#c9cccf]
    bg-white
    text-sm text-[#202223]
    hover:bg-[#f6f6f7]
    transition
  "
    >
       {lang === "AR" ? "تصفح" : "Browse"}
    </button>
  </div>

  {/* SELECTED */}
  {selectedBuyProduct && (
  <div className="mt-3 border border-[#e1e3e5] rounded-[14px] p-3 flex items-center justify-between bg-white">

    {/* LEFT */}
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-12 h-12 rounded-lg overflow-hidden bg-[#f6f6f7] border">
        {products.find(p => p.id === selectedBuyProduct.id)?.image && (
          <img
            src={products.find(p => p.id === selectedBuyProduct.id).image}
            alt=""
            className="w-full h-full object-cover"
          />
        )}
      </div>

      <div className="min-w-0">
        <div className="text-sm font-semibold text-[#202223] truncate">
          {selectedBuyProduct.name}
        </div>

        <div className="text-xs text-[#6d7175]">
          {products.find(p => p.id === selectedBuyProduct.id)?.public_id}
        </div>
      </div>
    </div>

    {/* REMOVE */}
    <button
      onClick={() => setSelectedBuyProduct(null)}
      className="text-xs text-red-600 hover:underline"
    >
      {lang === "AR" ? "إزالة" : "Remove"}
    </button>

  </div>
)}
</div>

{/* SECTION 2.1 */}
<div className={card}>
  <h3 className="text-[15px] font-semibold">
    {lang === "AR" ? "العميل يحصل من" : "Customer gets from"}
  </h3>

  <div className="flex gap-2">
    <input
      value={productSearch}
      onFocus={() => {
        setSelectionTarget("get");
       setProductSearch("");
setProductCategoryFilter("");
setSelectionModalOpen(true);
      }}
      className={input}
      placeholder={lang === "AR" ? "ابحث..." : "Search..."}
    />

    <button
      onClick={() => {
        setSelectionTarget("get");
        setProductSearch("");
setProductCategoryFilter("");
setSelectionModalOpen(true);
      }}
      className="
    w-[110px] h-[42px]
    rounded-[12px]
    border border-[#c9cccf]
    bg-white
    text-sm text-[#202223]
    hover:bg-[#f6f6f7]
    transition
  "
    >
       {lang === "AR" ? "تصفح" : "Browse"}
    </button>
  </div>

  {/* SELECTED */}
  {selectedGetProduct && (
  <div className="mt-3 border border-[#e1e3e5] rounded-[14px] p-3 flex items-center justify-between bg-white">

    {/* LEFT */}
    <div className="flex items-center gap-3 min-w-0">
      <div className="w-12 h-12 rounded-lg overflow-hidden bg-[#f6f6f7] border">
        {products.find(p => p.id === selectedGetProduct.id)?.image && (
          <img
            src={products.find(p => p.id === selectedGetProduct.id).image}
            alt=""
            className="w-full h-full object-cover"
          />
        )}
      </div>

      <div className="min-w-0">
        <div className="text-sm font-semibold text-[#202223] truncate">
          {selectedGetProduct.name}
        </div>

        <div className="text-xs text-[#6d7175]">
          {products.find(p => p.id === selectedGetProduct.id)?.public_id}
        </div>
      </div>
    </div>

    {/* REMOVE */}
    <button
      onClick={() => setSelectedGetProduct(null)}
      className="text-xs text-red-600 hover:underline"
    >
      {lang === "AR" ? "إزالة" : "Remove"}
    </button>

  </div>
)}
</div>

              {/* SECTION 6 */}
              <div className={card}>
                <h3 className="text-[15px] font-semibold text-[#202223]">
                  {lang==="AR" ? "تاريخ التفعيل" : "Active dates"}
                </h3>

                <p className={subtitle}>
                  {lang==="AR"
                    ? "حدد متى يبدأ وينتهي هذا الخصم"
                    : "Set when this discount starts and ends"}
                </p>

                {/* START */}
                  <div>
                    <label className="text-xs text-[#6d7175] mb-1 block">
                      {lang==="AR" ? "تاريخ البدء" : "Start date"}
                    </label>

                    <div className="grid grid-cols-2 gap-3">

                      {/* DATE */}
                      <button
                        type="button"
                        onClick={() => {
                          setDateTarget("start");
                          setDateModalOpen(true);
                        }}
                        className="flex items-center gap-2 h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm bg-white hover:border-[#008060]"
                      >
                        <FaCalendarAlt className="text-[#6d7175]" />
                        <span>{formatDisplayDate(startDate)}</span>
                      </button>

                      {/* TIME */}
                      <button
                        type="button"
                        onClick={() => {
                            setTimeTarget("start");

                            setTempTime({
                              hour: 12,
                              minute: "00",
                              period: "AM",
                            });

                            setTimeModalOpen(true);
                          }}
                        className="flex items-center gap-2 h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm bg-white hover:border-[#008060]"
                      >
                        <FaClock className="text-[#6d7175]" />
                        <span>{formatDisplayTime(startTime)}</span>
                      </button>

                    </div>
                  </div>

                <label className="flex items-center gap-2 text-sm mt-2">
                  <input type="checkbox" checked={hasEnd} onChange={()=>setHasEnd(!hasEnd)} />
                  {lang==="AR" ? "تاريخ انتهاء" : "Set end date"}
                </label>

                {hasEnd && (
                  <div className="mt-3">

                    <label className="text-xs text-[#6d7175] mb-1 block">
                      {lang==="AR" ? "تاريخ الانتهاء" : "End date"}
                    </label>

                    <div className="grid grid-cols-2 gap-3">

                      <button
                        type="button"
                        onClick={() => {
                          setDateTarget("end");
                          setDateModalOpen(true);
                        }}
                        className="flex items-center gap-2 h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm bg-white hover:border-[#008060]"
                      >
                        <FaCalendarAlt className="text-[#6d7175]" />
                        <span>{formatDisplayDate(endDate)}</span>
                      </button>

                      <button
                        type="button"
                        onClick={() => {
                          setTimeTarget("end");

                          setTempTime({
                            hour: 12,
                            minute: "00",
                            period: "AM",
                          });

                          setTimeModalOpen(true);
                        }}
                        className="flex items-center gap-2 h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm bg-white hover:border-[#008060]"
                      >
                        <FaClock className="text-[#6d7175]" />
                        <span>{formatDisplayTime(endTime)}</span>
                      </button>

                    </div>

                  </div>
                )}
              </div>

            </div>

            {/* ================= RIGHT ================= */}
            <div className="space-y-3">

{/* STATUS (EDIT ONLY) */}
{isEdit && (
  <div className={card}>
    <h3 className="text-[15px] font-semibold text-[#202223]">
      {lang === "AR" ? "الحالة" : "Status"}
    </h3>

    <p className={subtitle}>
      {lang === "AR"
        ? "حدد ما إذا كان الخصم نشطًا أو غير نشط"
        : "Control whether this discount is active or inactive"}
    </p>

    <div className="relative">
      <select
        value={isActive ? "active" : "inactive"}
        onChange={(e) => {
  setIsActive(e.target.value === "active" ? 1 : 0);
}}
        className={select}
      >
        <option value="active">
          {lang === "AR" ? "نشط" : "Active"}
        </option>

        <option value="inactive">
          {lang === "AR" ? "غير نشط" : "Inactive"}
        </option>
      </select>

      {/* Shopify arrow */}
      <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6d7175]">
        ▾
      </div>
    </div>

    {/* OPTIONAL VISUAL BADGE */}
    <div className="mt-2">
      <span
        className={`
          text-[11px] px-2.5 py-[3px] rounded-md font-medium
          ${isActive
            ? "bg-green-50 text-green-700"
            : "bg-gray-100 text-gray-600"}
        `}
      >
        {isActive
          ? (lang === "AR" ? "نشط" : "Active")
          : (lang === "AR" ? "غير نشط" : "Inactive")}
      </span>
    </div>
  </div>
)}

              <div className={card}>
                <h3 className="text-[15px] font-semibold text-[#202223]">  {lang === "AR" ? "الملخص" : "Summary"}</h3>

                <div className="bg-[#f6f6f7] border border-[#e1e3e5] rounded-[14px] p-4 text-[14px] leading-relaxed text-[#202223]">
                    {buildSummary()}
                  </div>
              </div>

            </div>

          </div>
         </div>
        </main>
      </div>
{showLeaveConfirm && (
  <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
    <div className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl">

      <div className="px-5 py-4 border-b">
        <h3 className="text-lg font-semibold">
          {lang === "AR" ? "مغادرة الصفحة؟" : "Leave page?"}
        </h3>
      </div>

      <div className="p-5 text-sm text-[#202223]">
        {lang === "AR"
          ? "لديك تغييرات غير محفوظة. إذا غادرت سيتم فقدانها."
          : "You have unsaved changes. If you leave, they will be lost."}
      </div>

      <div className="px-5 py-4 border-t flex justify-end gap-3">

        <button
          onClick={() => setShowLeaveConfirm(false)}
          className="px-4 py-2 border rounded"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={() => {
            setShowLeaveConfirm(false);
            pendingNavigation && pendingNavigation();
          }}
          className="px-4 py-2 bg-black text-white rounded"
        >
          {lang === "AR" ? "مغادرة" : "Leave"}
        </button>

      </div>
    </div>
  </div>
)}

      {selectionModalOpen && (
  (selectionTarget === "buy" && buyAppliesTo === "products") ||
  (selectionTarget === "get" && getAppliesTo === "products")
) && (
  <div
    className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4"
    onClick={() => setSelectionModalOpen(false)}
  >
    <div
      onClick={(e) => e.stopPropagation()}
      className="w-full max-w-[640px] bg-white rounded-[18px] border shadow-xl overflow-hidden"
    >

      {/* HEADER */}
      <div className="px-6 py-4 border-b bg-[#f6f6f7] flex justify-between">
        <h3 className="font-semibold">
          {lang === "AR" ? "اختر المنتجات" : "Select products"}
        </h3>
        <button onClick={() => setSelectionModalOpen(false)}>✕</button>
      </div>

      {/* SEARCH + FILTER */}
      <div className="p-4 border-b border-[#e1e3e5]">
        <div className="flex flex-col sm:flex-row gap-2">

  {/* SEARCH */}
  <div className="flex-1 h-[42px] border border-[#c9cccf] focus-within:border-[#008060] rounded-[12px] px-4 bg-white flex items-center gap-3 transition">
    <FaSearch className="text-[#6d7175] text-sm" />
    <input
      autoFocus
      value={productSearch}
      onChange={(e) => setProductSearch(e.target.value)}
      placeholder={lang === "AR" ? "ابحث..." : "Search products"}
      className="flex-1 outline-none text-sm text-[#202223]"
    />
  </div>

  {/* CATEGORY FILTER */}
  <div className="sm:w-[200px] relative">
    <select
      value={productCategoryFilter}
      onChange={(e) => setProductCategoryFilter(e.target.value)}
      className="w-full h-[42px] rounded-[12px] border border-[#c9cccf] px-3 text-sm bg-white text-[#202223] appearance-none"
    >
      <option value="">
        {lang === "AR" ? "كل الفئات" : "All categories"}
      </option>

      {categories.map((c) => (
        <option key={c.id} value={c.id}>
          {lang === "AR" ? c.name_ar : c.name_en}
        </option>
      ))}
    </select>

    {/* Shopify arrow */}
    <div className="absolute right-3 top-1/2 -translate-y-1/2 text-[#6d7175] pointer-events-none">
      ▾
    </div>
  </div>

</div>
      </div>

      {/* TABLE HEADER */}
      <div className="grid grid-cols-[1fr_100px_120px] px-6 py-3 text-xs font-semibold text-[#6d7175] border-b bg-[#f6f6f7]">
        <div>{lang === "AR" ? "المنتج" : "Product"}</div>
        <div className="text-center">{lang === "AR" ? "الكمية" : "Qty"}</div>
        <div className="text-center">{lang === "AR" ? "السعر" : "Price"}</div>
      </div>

      {/* BODY */}
      <div className="h-[320px] overflow-y-auto">

        {filteredProducts.length === 0 ? (
          <div className="p-6 text-sm text-[#6d7175]">
            {lang === "AR" ? "لا توجد منتجات" : "No products"}
          </div>
        ) : (
          filteredProducts.map((p) => {
            const isOnSale = !!p.on_sale;
            const salePercent = Number(p.sale_percent || 0);
            const isSelected =
  selectionTarget === "buy"
    ? selectedBuyProduct?.id === p.id
    : selectedGetProduct?.id === p.id;

            const totalQty = Array.isArray(p.variants)
              ? p.variants.reduce((sum, v) => sum + Number(v.stock_qty || 0), 0)
              : 0;

            return (
              <React.Fragment key={p.id}>
                <div
  onClick={() => {

    if (selectionTarget === "buy") {
      setSelectedBuyProduct({
        id: p.id,
        name: lang === "AR" ? p.name_ar : p.name_en,
      });
    } else {
      setSelectedGetProduct({
        id: p.id,
        name: lang === "AR" ? p.name_ar : p.name_en,
      });
    }

    setSelectionModalOpen(false);
  }}
  className={`grid grid-cols-[1fr_100px_120px] items-center px-6 py-3 border-b transition ${
    isSelected
      ? "bg-[#eef7f3] cursor-pointer"
      : "hover:bg-[#f6f6f7] cursor-pointer"
  }`}
>
  {/* PRODUCT */}
  <div className="flex items-center gap-3 min-w-0">
    <div className="w-10 h-10 rounded-lg overflow-hidden bg-[#f6f6f7] border border-[#e1e3e5] flex-shrink-0">
      {p.image && (
        <img src={p.image} className="w-full h-full object-cover" />
      )}
    </div>

    <div className="min-w-0 flex-1">
      <div className="flex items-center gap-2 min-w-0">
        <span className="truncate text-sm font-semibold text-[#202223]">
          {lang === "AR" ? p.name_ar : p.name_en}
        </span>

        {isOnSale && (
          <span className="shrink-0 text-[10px] px-2 py-[2px] rounded-full bg-[#ffe7e7] text-[#d72c0d] font-semibold border border-[#ffc9c9]">
            {salePercent}% OFF
          </span>
        )}
      </div>

      <div className="text-xs text-[#6d7175] truncate">
        {p.public_id}
      </div>

      {/* SALE WARNING */}
      {isOnSale && (
        <div className="mt-1 flex items-center gap-2 min-w-0">
          <span className="truncate text-[11px] text-[#b42318] font-medium">
            {lang === "AR"
              ? "يحتوي على خصم نشط"
              : "Already has an active sale"}
          </span>

          <button
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              setRemoveSaleProduct(p);
              setConfirmRemoveSaleOpen(true);
            }}
            className="shrink-0 h-6 px-2 rounded-md border border-[#f1b5b5] bg-white text-[#d72c0d] text-[11px] font-medium hover:bg-[#fff5f5] transition"
          >
            {lang === "AR" ? "إزالة" : "Remove"}
          </button>
        </div>
      )}
    </div>
  </div>

  {/* QTY */}
  <div className="text-center text-sm text-[#202223]">
    {totalQty}
  </div>

  {/* PRICE */}
  <div className="text-center text-sm font-medium text-[#202223]">
    ${Number(p.base_price || 0).toFixed(2)}
  </div>
</div>
              </React.Fragment>
            );
          })
        )}

      </div>

      {/* FOOTER */}
      <div className="px-6 py-4 border-t flex justify-end">
        <button
          onClick={() => setSelectionModalOpen(false)}
          className="px-4 py-2 bg-black text-white rounded"
        >
          {lang === "AR" ? "تم" : "Done"}
        </button>
      </div>

    </div>
  </div>
)}

{confirmRemoveSaleOpen && (
  <div className="fixed inset-0 bg-black/40 z-[80] flex items-center justify-center">
    <div className="w-full max-w-[400px] bg-white rounded-[18px] p-5">

      <h3 className="font-semibold mb-2">
        {lang === "AR" ? "إزالة الخصم" : "Remove sale"}
      </h3>

      <p className="text-sm text-[#6d7175] mb-5">
        {lang === "AR"
          ? "هل تريد إزالة الخصم من هذا المنتج؟"
          : "Are you sure you want to remove the sale from this product?"}
      </p>

      <div className="flex justify-end gap-3">
        <button
          onClick={() => setConfirmRemoveSaleOpen(false)}
          className="px-4 py-2 border rounded"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={async () => {
            try {
              await removeProductsFromSale([removeSaleProduct.id]);

              setProducts(prev =>
                prev.map(p =>
                  p.id === removeSaleProduct.id
                    ? { ...p, on_sale: false, sale_percent: 0 }
                    : p
                )
              );

              setRemoveSaleProduct(null);
              setConfirmRemoveSaleOpen(false);

            } catch (e) {
              console.error(e);
            }
          }}
          className="px-4 py-2 bg-black text-white rounded"
        >
          {lang === "AR" ? "تأكيد" : "Confirm"}
        </button>
      </div>

    </div>
  </div>
)}

{showConfirm && (
  <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center p-4">
    <div className="w-full max-w-[420px] bg-white rounded-[18px] border border-[#e1e3e5] shadow-xl">

      <div className="px-5 py-4 border-b">
        <h3 className="text-lg font-semibold text-[#202223]">
          {lang === "AR" ? "تأكيد حفظ الخصم" : "Confirm discount save"}
        </h3>
      </div>

      <div className="p-5 text-sm text-[#202223] space-y-2">
        <p>
          <strong>{lang === "AR" ? "نوع الخصم:" : "Discount type:"}</strong>{" "}
          {discountType === "percentage" ? "%" : "$"}
        </p>
        <p>
          <strong>{lang === "AR" ? "القيمة:" : "Value:"}</strong> {discountValue}
        </p>
        <p>
          <strong>{lang === "AR" ? "ينطبق على:" : "Applies to:"}</strong>{" "}
          {appliesToType === "products"
            ? (lang === "AR" ? "منتجات" : "Products")
            : (lang === "AR" ? "مجموعات" : "Collections")}
        </p>
      </div>

      <div className="px-5 py-4 border-t flex justify-end gap-3">
        <button
          onClick={() => setShowConfirm(false)}
          className="px-4 py-2 border rounded"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={handleSave}
          disabled={saving}
          className={`px-4 py-2 rounded text-white ${
            saving ? "bg-gray-400 cursor-not-allowed" : "bg-black"
          }`}
        >
          {saving ? (lang === "AR" ? "جارٍ الحفظ..." : "Saving...") : (lang === "AR" ? "تأكيد" : "Confirm")}
        </button>
      </div>

    </div>
  </div>
)}


      {dateModalOpen && (
  <div className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
  onClick={() => setDateModalOpen(false)}>
    <div
  className="w-[340px] bg-white rounded-[18px] shadow-[0_30px_60px_rgba(0,0,0,0.16)] overflow-hidden"
  onClick={(e) => e.stopPropagation()}
>

      {/* HEADER */}
      <div className="px-5 py-4 border-b">
        <h3 className="text-sm font-semibold">
          {lang === "AR" ? "اختر التاريخ" : "Select date"}
        </h3>
      </div>

      {/* BODY */}
      <div className="p-4">
        <CalendarRangePicker
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
          setRangeStart={setRangeStart}
          setRangeEnd={setRangeEnd}
        />
      </div>

      {/* FOOTER */}
      <div className="px-4 py-3 flex justify-end gap-2 border-t">

        <button
          onClick={() => setDateModalOpen(false)}
          className="h-[36px] px-4 border rounded-lg"
        >
          {lang === "AR" ? "إلغاء" : "Cancel"}
        </button>

        <button
          onClick={() => {
            if (!rangeStart) return;

            const date = `${rangeStart.getFullYear()}-${String(rangeStart.getMonth()+1).padStart(2,"0")}-${String(rangeStart.getDate()).padStart(2,"0")}`;

            if (dateTarget === "start") setStartDate(date);
            if (dateTarget === "end") setEndDate(date);

            setDateModalOpen(false);
          }}
          className="h-[36px] px-4 bg-black text-white rounded-lg"
        >
          {lang === "AR" ? "تطبيق" : "Apply"}
        </button>

      </div>
    </div>
  </div>
)}

{timeModalOpen && (
<div
  className="fixed inset-0 bg-black/40 flex items-center justify-center z-50"
  onClick={() => setTimeModalOpen(false)}
>
   <div
  className="w-[320px] bg-white rounded-[18px] shadow-[0_30px_60px_rgba(0,0,0,0.16)]"
  onClick={(e) => e.stopPropagation()}
>

      {/* HEADER */}
      <div className="px-5 py-4 border-b">
        <h3 className="text-sm font-semibold">
          {lang === "AR" ? "اختر الوقت" : "Select time"}
        </h3>
      </div>

      {/* BODY */}
      <div className="p-4">
        <TimePicker
            tempTime={tempTime}
            setTempTime={setTempTime}
          />
      </div>

      {/* FOOTER */}
      <div className="px-4 py-3 flex justify-end">
        <button
          onClick={() => {
            let hour = tempTime.hour;

            if (tempTime.period === "PM" && hour !== 12) hour += 12;
            if (tempTime.period === "AM" && hour === 12) hour = 0;

            const final = `${String(hour).padStart(2, "0")}:${tempTime.minute}`;

            if (timeTarget === "start") setStartTime(final);
            if (timeTarget === "end") setEndTime(final);

            setTimeModalOpen(false);
          }}
          className="h-[36px] px-4 bg-black text-white rounded-lg"
        >
          {lang === "AR" ? "تم" : "Done"}
        </button>
      </div>

    </div>
  </div>
)}
    </div>
  );
}

export default AdminCreateBXGYDiscount;